import { DocumentWithEmbeddedEntries } from 'libs/contentful/props';
import FiveStars from 'components/shared/Icons/FiveStar';
import RichTextHeadline from 'components/shared/RichTextHeadline/RichTextHeadline';
import RichTextCopy from 'components/shared/RichTextCopy/RichTextCopy';
import { Sys } from 'libs/contentful/props';
import { BentoBoxMainSectionOrientation } from 'types/constants';
import { cn } from 'utils/styles';
import { ContentfulRichTextBlock } from 'libs/contentful/props';
import { liveUpdateAttrs } from 'libs/contentful/utils';

export interface BentoBoxMainSectionProps {
  sys?: Sys;
  orientation: BentoBoxMainSectionOrientation;
  headline?: DocumentWithEmbeddedEntries;
  copy?: DocumentWithEmbeddedEntries;
  eyebrowRte?: ContentfulRichTextBlock;
  displayFiveStarEyebrow?: boolean;
}

const BentoBoxMainSection = ({
  sys,
  copy,
  headline,
  orientation,
  eyebrowRte,
  displayFiveStarEyebrow,
}: BentoBoxMainSectionProps) => {
  const isHorizontal = orientation == BentoBoxMainSectionOrientation.Horizontal;
  const isVertical = orientation == BentoBoxMainSectionOrientation.Vertical;

  return (
    <section className={`flex ${cn({ 'flex-col md:flex-row w-full gap-6': isHorizontal, 'flex-col': isVertical })}`}>
      {eyebrowRte && (
        <span className="font-sans font-medium text-eyebrow" {...liveUpdateAttrs(sys?.id, 'eyebrowRte')}>
          <RichTextCopy copy={eyebrowRte} />
        </span>
      )}
      {displayFiveStarEyebrow && <FiveStars />}
      {headline && (
        <div
          className={`text-heading-md md:text-heading-lg font-sans font-semibold ${cn({ 'basis-1/2': isHorizontal, 'mt-6 mb-6': isVertical })}`}
          {...liveUpdateAttrs(sys?.id, 'headline')}>
          <RichTextHeadline headline={headline}></RichTextHeadline>
        </div>
      )}
      {copy && (
        <div
          className={`font-serif text-lg ${cn({ 'basis-1/2': isHorizontal })}`}
          {...liveUpdateAttrs(sys?.id, 'copy')}>
          <RichTextCopy copy={copy}></RichTextCopy>
        </div>
      )}
    </section>
  );
};

export default BentoBoxMainSection;
